import { apiSlice } from 'api/apiSlice';
import { toCamelCase } from 'utils/utilities';
import { endpoints } from 'helper/endpoints';

export const govtIdApi = apiSlice.injectEndpoints({
    endpoints: (builder) => ({
        // Document-confirm: charge the document verification for a submitted side.
        chargeDocumentVerification: builder.mutation({
            query: (payload) => ({
                url: endpoints.chargeDocument,
                method: 'POST',
                data: payload,
            }),
        }),

        // Document-confirm: front-of-document OCR. Caller passes { image }.
        getDocumentOcr: builder.mutation({
            query: (data) => ({
                url: endpoints.documentFrontOcr,
                method: 'POST',
                data,
            }),
        }),

        // useCaptureSelfie: selfie verification (normal flow only).
        verifySelfie: builder.mutation({
            query: ({ selfieImage, documentType }) => ({
                url: endpoints.verifySelfie,
                method: 'POST',
                data: { selfieImage, documentType },
            }),
        }),

        // Manual review: persist the selfie image plus its liveness/face-match result.
        saveSelfieAndLiveness: builder.mutation({
            query: ({
                documentType,
                liveness = {
                    livenessScoreResult: { score: 0, livenessAssessment: null },
                    error: null,
                    errorCode: null,
                    transactionId: null,
                },
                faceMatch = 0,
                selfieImage = null,
            }) => ({
                url: endpoints.saveLiveness,
                method: 'POST',
                data: { documentType, liveness, faceMatch, selfieImage },
            }),
        }),

        // processDataActions / Results / Error: save document result.
        saveIdResult: builder.mutation({
            query: (data) => ({
                url: endpoints.saveDocumentResult,
                method: 'POST',
                data: toCamelCase(data),
            }),
        }),

        // Results/index: save selfie liveness result.
        saveSelfieLivenessResult: builder.mutation({
            query: (data) => ({
                url: endpoints.saveLivenessResult,
                method: 'POST',
                data: toCamelCase(data),
            }),
        }),

        // Dumps the AssureID result to the backend before it is consumed.
        // Invoked from acuantApi.getResults onQueryStarted (preserves the prior
        // getResults → dump(result) side-effect).
        dumpResult: builder.mutation({
            query: (data) => ({
                url: endpoints.resultComplete,
                method: 'POST',
                data,
            }),
        }),
    }),
    overrideExisting: true,
});

export const {
    useChargeDocumentVerificationMutation,
    useGetDocumentOcrMutation,
    useVerifySelfieMutation,
    useSaveSelfieAndLivenessMutation,
    useSaveIdResultMutation,
    useSaveSelfieLivenessResultMutation,
    useDumpResultMutation,
} = govtIdApi;
